<template>
  <div class="scrollTop" ref="scrollTop"></div>
  <StageOne
    @emitAddress="receiveAddress"
    @changeStage="changeStage"
    v-if="stage === 1"
  />
  <ThankYou v-else-if="stage === 6" />
  <StageTwo
    :stage="stage"
    :showBudget="budget"
    :initialAddress="address"
    @changeStage="changeStage"
    v-else
  />
</template>

<script lang="ts" setup>
import StageOne from "@/components/StageOne.vue";
import StageTwo from "@/components/StageTwo.vue";
import { ref } from "vue";
import { get, set } from "@vueuse/core";
import type { AddressLocation } from "@/types";
import ThankYou from "@/components/ThankYou.vue";

defineProps({
  budget: {
    type: String,
    default: "false"
  }
})

const scrollTop = ref<HTMLDivElement | null>(null);

const address = ref<AddressLocation>({
  lat: undefined,
  long: undefined,
  address: undefined,
  postNumber: undefined,
  postAddress: undefined,
});
const stage = ref<number>(1);

// Sets address emitted from child component stage one
function receiveAddress(
  lat: number,
  long: number,
  formattedAddress: string,
  postNumber: string,
  postAddress: string,
  instant: boolean
) {
  get(address).lat = lat;
  get(address).long = long;
  get(address).address = formattedAddress;
  get(address).postNumber = postNumber;
  get(address).postAddress = postAddress;
  if (instant) {
    changeStage(1);
  }
}

// Function that changes stage
function changeStage(s: number) {
  if (get(stage) === 1) {
    if (
      "lat" in get(address) &&
      "long" in get(address) &&
      get(address).lat !== undefined &&
      get(address).long !== undefined
    ) {
      set(stage, get(stage) + s);
    } else {
      console.log("Address not set!");
      return;
    }
  } else {
    set(stage, get(stage) + s);
  }
  if (scrollTop) {
    scrollTop.value?.scrollIntoView({ behavior: "smooth" });
  }
}
</script>
